let overlay = null;

const OVERLAY_CLASSES = {
  invertColors: 'pb-a11y-visual-overlay--invert',
  monochrome: 'pb-a11y-visual-overlay--monochrome',
};

function countActiveOverlays() {
  if (!overlay) return 0;
  return Object.values(OVERLAY_CLASSES).filter((c) => overlay.classList.contains(c)).length;
}

export function applyVisualOverlay(type, enabled) {
  const cls = OVERLAY_CLASSES[type];
  if (!cls) return;

  if (enabled) {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'pb-a11y-visual-overlay';
      overlay.setAttribute('aria-hidden', 'true');
    }

    overlay.classList.add(cls);

    if (!overlay.parentNode) {
      document.body.appendChild(overlay);
    }
  } else {
    if (overlay) {
      overlay.classList.remove(cls);
      if (countActiveOverlays() === 0) {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
        overlay = null;
      }
    }
  }
}

export function removeVisualOverlay() {
  if (overlay && overlay.parentNode) {
    overlay.parentNode.removeChild(overlay);
  }
  overlay = null;
}
